import MKMReport from './mkmReport';

export default [MKMReport];
